// extracted by mini-css-extract-plugin
export var actionButton = "_oy-0";
export var actionMenuContainer = "_oy-i";
export var bubble = "_oy-2";
export var bubbleActionMenu = "_oy-j";
export var bubbleContext = "_oy-6";
export var bubbleItems = "_oy-7";
export var customer = "_oy-3";
export var divider = "_oy-8";
export var fileList = "_oy-9";
export var hiddenComment = "_oy-o";
export var infoAbove = "_oy-a";
export var internal = "_oy-4";
export var lightActionButton = "_oy-1";
export var link = "_oy-b";
export var merchant = "_oy-5";
export var message = "_oy-c";
export var profilePicture = "_oy-e";
export var quillToolbarContainer = "_oy-f";
export var senderDate = "_oy-g";
export var senderDateCustomer = "_oy-h";
export var senderName = "_oy-d";
export var time = "_oy-k";
export var uploadedImage = "_oy-l";
export var username = "_oy-m";
export var xsmall = "_oy-n";